import { render, staticRenderFns } from "./PageItem.vue?vue&type=template&id=02c6a172"
import script from "./PageItem.vue?vue&type=script&lang=js"
export * from "./PageItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('02c6a172')) {
      api.createRecord('02c6a172', component.options)
    } else {
      api.reload('02c6a172', component.options)
    }
    module.hot.accept("./PageItem.vue?vue&type=template&id=02c6a172", function () {
      api.rerender('02c6a172', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PageItem.vue"
export default component.exports